import { Component, OnInit } from '@angular/core';
import { DragAndDropBaseComponent } from '../drag-and-drop-base-component/drag-and-drop-base.component';
import { DealerService } from './../../../../shared/services/dealer/dealer.service';
import { TranslatorService } from './../../../../shared/services/utils/translator.service';

@Component({
  selector: 'ngx-dealer-drag-and-drop',
  templateUrl: './../drag-and-drop-base-component/drag-and-drop-base.component.html',
  styleUrls: ['./../drag-and-drop-base-component/drag-and-drop-base.component.scss']
})
export class DealerDragAndDropComponent extends DragAndDropBaseComponent implements OnInit {

  constructor(  private readonly dealerService: DealerService, translatorService: TranslatorService) {
    super(translatorService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.dealerService.dealersQuery$(null, null).subscribe(res => {
      this.itemsList = this.itemsList.concat(res.dealerList);
    });

  }

}
